import * as angular from "angular";
import {UserService} from "../../common/user/user.service";
import {CurrentUser} from "../../models/user/user.model";
import {GroupsService} from "../../common/groups/groups.service";
import {Group} from "../../models/groups/group.model";
import {NavigationMenuService} from "../../common/top-nav/navigation-menu.service";
import {NavigationMenu} from "../../models/navigation-menu/navigation-menu.model";
import {LayoutUser} from "../../models/layout-window.model";
import {InstitutionService} from "../../common/institution/institution-service";
import {Institution} from "../../models/institution.model";
import {UserSessionService} from "../../common/user-session/user-session.service";
import {PreferenceService} from "../../common/preference/preference.service";
import {Preference} from "../../models/preference.model";
import {LayoutInitService} from "../../layout-init/layout-init.service";
import {StudyProgramsService} from "../../common/study-programs/study-programs.service";
import {FeatureService} from "../../common/feature/feature.service";

export interface GroupsInit {
    groups?: Group[];
    institution?: Institution;
    district: boolean;
    districtAdmin: boolean;
    currentUser: CurrentUser;
    tenantId: string;
}

export interface GroupsInitService { (tenantId: string): angular.IPromise<GroupsInit>; }

/* @ngInject */
export function groupsInitService(userService: UserService,
                                  groupsService: GroupsService,
                                  institutionService: InstitutionService,
                                  studyProgramsService: StudyProgramsService,
                                  navigationMenuService: NavigationMenuService,
                                  featureService: FeatureService,
                                  userSessionService: UserSessionService,
                                  $q: angular.IQService, preferenceService: PreferenceService,
                                  layoutInitService: LayoutInitService): GroupsInitService {
    function isDistrictUserAccessingDistrict(currentUser: CurrentUser, tenantId: string): boolean {
        return currentUser.districtUser && tenantId === currentUser.tenantId;
    }

    function populateNavBar(navigationMenu: NavigationMenu) {
        userSessionService.setNavigationMenu(navigationMenu);
    }

    function populateFooter(currentUser: CurrentUser, institution: Institution) {
        let layoutUser: LayoutUser = {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            highSchoolName: institution.name
        };
        userSessionService.setLayoutUser(layoutUser);
    }

    function saveDistrictPreferenceForSchool(preferenceData: Preference) {
        let value = !preferenceData.preferences ||
            !preferenceData.preferences.districtManagedDefaultGroups;
        userSessionService.setTenantManagingDefaults(value);
    }

    return (tenantId: string): angular.IPromise<GroupsInit> => {
        let initData: GroupsInit = {
            district: false,
            districtAdmin: false,
            currentUser: void 0,
            tenantId: tenantId

        };
        return userService.get().then((currentUser: CurrentUser) => {
            initData.currentUser = currentUser;
            if (currentUser.preferences) {
                let hideModal = currentUser.preferences.testprepWelcomeModal === false;
                if (hideModal) { userSessionService.setHideWelcomeModal(); }
            }

            let togglesPromise = featureService();

            let studyProgramsPromise = studyProgramsService.getSubscriptionStudyPrograms(tenantId)
                .then((subscriptionStudyPrograms) => {
                    userSessionService.setSubscriptionStudyPrograms(subscriptionStudyPrograms);
                });
            
            if (isDistrictUserAccessingDistrict(currentUser, tenantId)) {
                initData.district = true;
                initData.districtAdmin = currentUser.isDistrictAdmin();
                if (initData.districtAdmin) {
                    userSessionService.setDistrictMode(tenantId, true);
                }
                let navMenuPromise = navigationMenuService(tenantId, initData.district).then(populateNavBar);
                let institutionPromise = institutionService(tenantId).then((institution: Institution) => {
                    initData.institution = institution;
                    populateFooter(currentUser, institution);
                });
                return $q.all([togglesPromise, studyProgramsPromise, navMenuPromise, institutionPromise]).then(() => {
                    userSessionService.setTenantManagingDefaults(true);
                    layoutInitService(initData);
                    return initData;
                });
            } else {
                userSessionService.setDistrictMode(tenantId, initData.district);
                let navMenuPromise = navigationMenuService(tenantId).then(populateNavBar);
                let groupsPromise = groupsService.getAll(tenantId).then((groups: Group[]) => {
                    initData.groups = groups;
                });
                let preferencePromise = institutionService(tenantId).then((institution: Institution) => {
                  initData.institution = institution;
                    populateFooter(currentUser, institution);
                    if (institution.parent) {
                        return preferenceService.getInstitutionPreference(institution.parent)
                            .then(saveDistrictPreferenceForSchool);
                    } else {
                        userSessionService.setTenantManagingDefaults(true);
                    }
                });
                return $q
                    .all([togglesPromise, studyProgramsPromise, navMenuPromise, preferencePromise, groupsPromise])
                    .then(() => {
                        layoutInitService(initData);
                        return initData;
                    });
            }
        });
    };
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/groups/groups-init/groups-init.service.ts
 **/